/**
 * Shared Shiki highlighter used by the markdown reader.
 *
 * Must be sync at call-time because react-markdown runs rehype plugins via
 * `runSync`. We top-level-await `createHighlighter` at module load — Vite
 * supports TLA with our es2022 target.
 */
import { createHighlighter, type Highlighter } from "shiki";

const LANGS = [
  "bash",
  "sh",
  "shell",
  "c",
  "cpp",
  "css",
  "diff",
  "docker",
  "dockerfile",
  "go",
  "graphql",
  "html",
  "http",
  "java",
  "js",
  "javascript",
  "json",
  "jsx",
  "kotlin",
  "lua",
  "make",
  "makefile",
  "md",
  "markdown",
  "nginx",
  "php",
  "powershell",
  "python",
  "ruby",
  "rust",
  "scss",
  "sql",
  "swift",
  "toml",
  "ts",
  "typescript",
  "tsx",
  "xml",
  "yaml",
];

export const highlighter: Highlighter = await createHighlighter({
  themes: ["github-light", "github-dark"],
  langs: LANGS,
});
